<template>
  <div id="chat">
    <RoomChats></RoomChats>
  </div>
</template>

<script>
import RoomChats from './components/RoomChatsComponent.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    // Chats,
    RoomChats,
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto Mono:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap');
#chat {
    font-family: Roboto, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    /*background: #95d5b2;*/
    margin: 0 auto;
    width: 100%;
    /*border-radius: 10px;*/
    /*margin-top: 30px;*/
    /*padding: 20px;*/
}
</style>
